import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './PageMenu.scss'

export const PageMenu = ({ items, className }) => {
  return (
    <div className={classnames('c-page-menu', className)}>
      <ul className='c-page-menu__items'>
        {items.map(({ label, href, onClick, isActive, ...otherProps }, i) => (
          <li
            className={classnames('c-page-menu__item', {
              'c-page-menu__item--active': isActive
            })}
            key={`page-menu-item-${i}`}
          >
            <a
              href={href}
              onClick={e => typeof onClick === 'function' && onClick(e)}
              {...otherProps}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

PageMenu.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      className: PropTypes.string,
      isActive: PropTypes.bool,
      onClick: PropTypes.func
    })
  )
}
